export default function ellipsisWrapper(string, maxLength) {
    // pacman in the middle implementation
    if (string.length > maxLength) {
        const reducedLength = maxLength - 2; // -2 accounts for the '..'

        if (!string.includes('@')) {
            return string.slice(0, reducedLength).concat('..');
        }

        const [userName, domain] = string.split('@');

        const excessLength = string.length - reducedLength;

        let removeOnlyFromOneSide = Math.abs(userName.length - domain.length);
        const removeFromEachSide = Math.round((excessLength - removeOnlyFromOneSide) / 2);

        if ((excessLength - removeOnlyFromOneSide) % 2 > 0) {
            removeOnlyFromOneSide += 1;
        }

        let removeFromDomain = removeFromEachSide;
        let removeFromUserName = removeFromEachSide + removeOnlyFromOneSide;

        if (domain.length > userName.length) {
            removeFromDomain = removeFromEachSide + removeOnlyFromOneSide;
            removeFromUserName = removeFromEachSide;
        }

        const domainRegex = new RegExp(`@.{${removeFromDomain}}`, 'gi');
        const userNameRegex = new RegExp(`.{${removeFromUserName}}@`, 'gi');
        return string.replace(domainRegex, '@..').replace(userNameRegex, '..@');
    }

    return string;
}
